import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { showVmsManagementDpiaLink } from '../constants/vmsAccessMatrix';
import { getVmsDefaultLandingPath } from '../utils/vmsRole';
import { PageLoader } from './LoadingStates';

/** DPIA definition library: admin, DPO, business owner, or business head. */
const VmsDpiaManagementRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <PageLoader message="Loading..." />;
  }
  if (!showVmsManagementDpiaLink(user)) {
    return <Navigate to={getVmsDefaultLandingPath(user)} replace />;
  }
  return <>{children}</>;
};

export default VmsDpiaManagementRoute;
